module.exports = __webpack_public_path__ + "img/integration-id.svg";